module.exports = __webpack_public_path__ + "img/Jack_Bensimon.b8d1294f.jpg";